var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerminalGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_83_387",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 0H0V56H56V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_83_387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.9778 50.2875L33.2137 23.6482L31.0923 20.6353L17.6698 1.5792L16.5578 0H0.0644989L4.087 5.7125L21.9337 31.0527L24.0551 34.0623L38.3945 54.4226L39.507 56.0005H56.0003L51.9778 50.2875ZM41.4672 52.3542L26.5696 31.202L24.4483 28.191L7.1611 3.6458H14.5971L28.5774 23.4957L30.6987 26.5067L48.9032 52.3537L41.4672 52.3542Z",
    fill: "#767A79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4484 28.1914L26.5697 31.2024L24.0547 34.0628L4.7584 56.0009H0L21.9334 31.0532L24.4484 28.1914Z",
    fill: "#767A79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0141 0L33.2135 23.6482L30.6985 26.5067L28.5771 23.4957L31.0921 20.6353L45.1822 4.6087L49.2556 0H54.0141Z",
    fill: "#767A79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalGray);
export default __webpack_public_path__ + "static/media/terminalGray.ff1a5ba31121491b8bd3d16ec82cfcfb.svg";
export { ForwardRef as ReactComponent };